exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".m-t-half{margin-top:5px}.m-t{margin-top:10px}.m-t-double{margin-top:20px}.m-r-half{margin-right:5px}.m-r{margin-right:10px}.m-r-double{margin-right:20px}.m-b-half{margin-bottom:5px}.m-b{margin-bottom:10px}.m-b-double{margin-bottom:20px}.m-l-half{margin-left:5px}.m-l{margin-left:10px}.m-l-double{margin-left:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/scss/common/box.scss
// module id = 594
// module chunks = 2